import { useCallback } from 'react';
import {
  useActionItem,
  ActionItemOperation as Operation,
} from '@workboard/action-item';

import { useAxios } from '../../hooks/useAxios';

export function useConvertSubAction(aiId: string, onUpdate?: () => void) {
  const { isPermitted, actionItem } = useActionItem(aiId);
  const canConvertToAi = isPermitted(Operation.convertToActionItem);
  const label = (actionItem?.typeAttributes?.label ?? 'action').toLowerCase();

  const [, postConvertToAi] = useAxios(
    {
      url: 'activity/UpdateParentId',
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'x-requested-with': 'XMLHttpRequest',
      },
    },
    { manual: true }
  );

  const convertToAi = useCallback(async () => {
    try {
      await postConvertToAi({
        data: { actId: aiId, parentId: null },
      });
      onUpdate?.();
      toastr?.success(`Subtask converted to ${label}.`);
    } catch (error) {
      toastr?.error(
        `There was a problem while converting to ${label}. Please try again later.`
      );
      console.error(error);
    }
  }, [postConvertToAi, aiId, onUpdate, label]);

  return [canConvertToAi, convertToAi] as const;
}
